import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "14", x: "4", y: "5", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "10", x: "14", y: "7", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 22v-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 7V2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 22v-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 5V2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AlignHorizontalDistributeCenter";
const AlignHorizontalDistributeCenter = memo(themed(Icon));
export {
  AlignHorizontalDistributeCenter
};
//# sourceMappingURL=align-horizontal-distribute-center.js.map
